import { Link } from "react-router-dom";
import "./Footer.css";
import cubex_logo from "../../assets/Logo-bg.png";
import { config } from "../../config";
import {
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
  FaFacebook,
} from "react-icons/fa6";

const cols = {
  Company: [
    { l: "Home", p: `${config.appUrl}` },
    { l: "About", p: `${config.appUrl}about` },
    { l: "Blog", p: `${config.appUrl}blog` },
    { l: "Contact", p: `${config.appUrl}contact` },
  ],
  Services: [
    {
      l: "Website Development",
      p: `${config.appUrl}services/web-development`,
    },
    {
      l: "Digital Marketing",
      p: `${config.appUrl}services/digital-marketing`,
    },
    { l: "Graphics Design", p: `${config.appUrl}services/graphics-design` },
  ],
  Packages: [
    { l: "Web Dev Package", p: `${config.appUrl}web-development-package` },
    { l: "Maintenance Package", p: `${config.appUrl}maintenance-package` },
    { l: "Privacy Policy", p: `${config.appUrl}privacy-policy` },
  ],
};

const socials = [
  { icon: <FaXTwitter />, url: "https://x.com/CubexTechnology" },
  {
    icon: <FaLinkedinIn />,
    url: "https://www.linkedin.com/company/cubextechnology/posts/?feedView=all",
  },
  { icon: <FaInstagram />, url: "https://www.instagram.com/cubextechnology?igsh=NHQ0YWV1N24zZXcw" },
  { icon: <FaFacebook />, url: "https://www.facebook.com/profile.php?id=61567936015225" },
];

export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          {/* brand */}
          <div>
            <div className="footer-logo">
              <img src={cubex_logo} />
            </div>
            <p className="footer-tagline">
              We craft transformative digital experiences that push the
              boundaries of technology and design.
            </p>
            <div className="social-links" style={{ marginTop: 24 }}>
              {socials.map((s) => (
                <a key={s.icon} href={s.url} className="social-link">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>
          {/* link cols */}
          {Object.entries(cols).map(([cat, items]) => (
            <div className="footer-col" key={cat}>
              <h4>{cat}</h4>
              <ul>
                {items.map((i) => (
                  <li key={i.l}>
                    <Link to={i.p}>{i.l}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} CubeX Technology. All rights reserved.
          </p>
          {/* <p>Crafted with <span style={{color:'var(--gold)'}}>✦</span> in Gujarat, India</p> */}
        </div>
      </div>
    </footer>
  );
}
